import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as S from "./styles";
import { DecorativeDot } from "../../../lib/styles";
import Loader from "../../../components/ui/Loader";
import { getMegaPages } from "../../../services/megaPage";
import GuideCard from "../../Guides/GuideCard";

export function LatestGuides() {
  const navigate = useNavigate();

  const [guides, setGuides] = useState(null);

  useEffect(() => {
    (async () => {
      const data = {
        limit: 1,
        offset: 0,
      };

      const result = await getMegaPages(data);

      setGuides(result.megaPages || []);
    })();
  }, []);

  const handleViewAll = () => {
    navigate("/guides");
  };

  const handleOpenGuide = () => {
    navigate(`/guide/${guides[0].slug}`);
  };

  return (
    <S.StyledSection>
      {!guides && (
        <Loader
          styles={{
            position: "absolute",
            left: "48%",
            top: "48%",
            width: "fit-content",
            height: "fit-content",
          }}
        />
      )}

      <S.ResourceContent>
        <S.BackgroundBlur />

        <S.ResourceContentFrame>
          <S.ResourceContentFrameHeader>Resources</S.ResourceContentFrameHeader>
          <S.ResourceContentFrameText>
            The Best Collection of Guides for{" "}
            <S.HeadingHighlight>Successful Campaigns</S.HeadingHighlight>
            <DecorativeDot
              src="/images/icons/dot-grey.svg"
              alt="Decorative dot"
            />
          </S.ResourceContentFrameText>
        </S.ResourceContentFrame>

        <S.ReadAllBtn onClick={handleViewAll}>
          Read all guides
          <img
            src="/images/icons/arrow-top-right-white.svg"
            alt="Arrow right"
          />
        </S.ReadAllBtn>
      </S.ResourceContent>

      {!!guides?.length && (
        <GuideCard data={guides[0]} onClick={handleOpenGuide} />
      )}
    </S.StyledSection>
  );
}
